import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import * as actionTypes from "./constants";
import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var btoa = require("Base64").btoa;
var history = createBrowserHistory();

function* sendOtpForgotPassword(value) {
  try {
    const data = { email: value.params.email };
    const res = yield fetch(`${appConfig.ip}/password-resets/sendotp`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.SEND_OTP_SUCCESS_ACTION,
        payload: resJSON,
      });

      yield toast.success("An OTP has been sent to the registered email", {
        autoClose: 3000,
        transition: Flip,
        className:"toastClass"
      });
      yield put(
        push("/forgotpassword?tab=verifyOtp", { email: value.params.email })
      );
      //yield put(push("/verifyotp"));
    }
  } catch (err) {
    if (err.status === 404) {
      yield toast.error(
        "User not found!! Try again with the registered email",
        {
          autoClose: 3000,
          transition: Flip,
          className:"toastClass"
        }
      );
    }

    yield put({
      type: actionTypes.SEND_OTP_FAIL_ACTION,
      payload: err,
    });
  }
}

function* otpVerifyForgotPassword(value) {
  console.log("vall", value);
  try {
    const data = { email: value.params.email, pin: value.params.otp };
    const res = yield fetch(`${appConfig.ip}/password-resets/checkpin/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.VERIFY_OTP_SUCCESS_ACTION,
        payload: resJSON,
      });
      if (resJSON.ok === true) {
        yield toast.success("OTP Verified", {
          autoClose: 3000,
          transition: Flip,
          className:"toastClass"
        });
        yield put(
          push("/forgotpassword?tab=resetPass", { email: value.params.email })
        );
      } else if (resJSON.ok === false && resJSON.attemptLeft !== 0) {
        yield toast.error(
          "You have entered a wrong OTP. You have " +
            resJSON.attemptLeft +
            " attempts left",
          {
            autoClose: 3000,
            transition: Flip,
            className:"toastClass"
          }
        );
      } else if (resJSON.ok === false && resJSON.attemptLeft === 0) {
        yield toast.error(
          "Redirecting to login page, since you have used your maximum attempts",
          {
            autoClose: 3000,
            transition: Flip,
            className:"toastClass"
          }
        );

        yield put({
          type: actionTypes.REDIRECT_INIT_ACTION,
        });
      }

      //yield put(push("/verifyotp"));
    }
  } catch (err) {
    if (err.status === 404) {
      yield toast.error(
        "Redirecting to login page, since you have used your maximum attempts",
        {
          autoClose: 5000,
          transition: Flip,
          className:"toastClass"
        }
      );
    }

    yield put({
      type: actionTypes.REDIRECT_INIT_ACTION,
    });

    yield put({
      type: actionTypes.VERIFY_OTP_FAIL_ACTION,
      payload: err,
    });
  }
}

function* reSendOtpForgotPassword(value) {
  try {
    const data = { email: value.params.email };
    const res = yield fetch(`${appConfig.ip}/password-resets/resendotp`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.RESEND_OTP_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success("OTP resend to the registered  email", {
        autoClose: 3000,
        transition: Flip,
        className:"toastClass"
      });
      yield put(
        push("/forgotpassword?tab=verifyOtp", { email: value.params.email })
      );
    }
  } catch (err) {
    if (err.status === 404) {
      yield toast.error("User not found!! Try again ", {
        autoClose: 3000,
        transition: Flip,
        className:"toastClass"
      });
    }

    yield put({
      type: actionTypes.RESEND_OTP_FAIL_ACTION,
      payload: err,
    });
  }
}

function* reSetNewpassword(value) {
  try {
    const data = {
      email: value.params.email,
      pin: value.params.otp,
      password: value.params.password,
    };
    const res = yield fetch(`${appConfig.ip}/password-resets/change`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.SET_NEW_PWD_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success(" Password reset success", {
        autoClose: 3000,
        transition: Flip,
        className:"toastClass"
      });
      yield put(push("/login"));
    }
  } catch (err) {
    if (err.status === 401) {
      yield toast.error("Unexpected Error", {
        autoClose: 3000,
        transition: Flip,
        className:"toastClass"
      });
    }

    yield put({
      type: actionTypes.SET_NEW_PWD_FAIL_ACTION,
      payload: err,
    });
  }
}

function* redirectTologin() {
  yield put({
    type: actionTypes.REDIRECT_SUCCESS_ACTION,
  });
  yield put(push("/login"));
}

export function* forgotPasswordActionWatcher() {
  yield takeEvery(actionTypes.SEND_OTP_INIT_ACTION, sendOtpForgotPassword);
  yield takeEvery(actionTypes.VERIFY_OTP_INIT_ACTION, otpVerifyForgotPassword);
  yield takeEvery(actionTypes.RESEND_OTP_INIT_ACTION, reSendOtpForgotPassword);
  yield takeEvery(actionTypes.SET_NEW_PWD_INIT_ACTION, reSetNewpassword);
  yield takeEvery(actionTypes.REDIRECT_INIT_ACTION, redirectTologin);
}
